export const list = [
    { key: "گوگل" },
    { key: "اینستاگرام" },
    { key: "سایر" },
];